$(document).ready(function () {
    // Header.init(600);
    // Cookiebar.init();

    Menu.init();
    // SearchAutocomplete.init();
    // Banner.init();
    Picture.init();
    // Homepage.init();
    // Popup.init();
    YouTubeVideo.resize();
    KBbanner.init();
    // Expander.init();
    // Ol.init();
    // Table.init();

    // Footer.pinBottom();

    // Articles.init();
    // Datepicker.init();
    // Galeria.Gallery.init();
    audioTrackInit();


    //  clickReference(referenceClicked);
    $("body").removeClass("hidden");
});


function audioTrackInit() {
    const _gaq = window._gaq || [];
    const audio = $("audio");
    audio.bind("play", function () {
        _gaq.push(["_trackEvent", "Audio", "play", $(this).find("source").attr("src")]);
        console.log('Audio track playing: ' + $(this).find("source").attr("src"));
    });

    audio.bind("ended", function () {
        _gaq.push(["_trackEvent", "Audio", "ended", $(this).find("source").attr("src")]);
        console.log('Audio track ended: ' + $(this).find("source").attr("src"));
    });
}

/*

function clickReference(referenceClicked) {
	console.log("som vo funkcii");
  if (referenceClicked === 0) {
	console.log("pustam sa prvykrat");
	$(".square1").css({ width: "255px", height: "255px",top: "130%", left: "-10%" });
	$(".square2").css({ width: "255px", height: "255px",top: "50%", left: "50%" });

	$(".square1").click(function() {
		$(".rectangle").css("opacity", "1"); 
		$(".square1").css({ width: "255px", height: "255px",top: "50%", left: "50%" });
		$(".square2").css({ width: "185px", height: "185px",top: "50%", left: "50%" });
		referenceClicked = 1;
	});
  } 
  else {

	moveReferenceText();
  }
}

*/

var resizeId;
$(window).resize(function () {
    clearTimeout(resizeId);
    resizeId = setTimeout(doneResizing, 300);
});

function doneResizing() {
    Menu.resize();
    // Footer.pinBottom();
    // Titulka.resize();
    // Banner.resize();
    // Expander.init();
    Header.resize();
    YouTubeVideo.resize();

    // BoxRotator.resize();
}

$(window).load(function () {
});

Iframe = {
    init: function (collection) {
        var iframe = $("iframe", collection || $("body"));

        if (!iframe.length) return;

        iframe.each(function (index, el) {
            $(this)
                .parent()
                .attr("load", "");
            $(this).load(function () {
                $(this)
                    .parent()
                    .removeAttr("load");
            });
        });
    }
};
